import { render } from "./Programma.vue?vue&type=template&id=c74c6eec&scoped=true"
import script from "./Programma.vue?vue&type=script&lang=js"
export * from "./Programma.vue?vue&type=script&lang=js"

import "./Programma.vue?vue&type=style&index=0&id=c74c6eec&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74c6eec"]])

export default __exports__